export const TEMPLATE_TYPE = {
  MULTI_COUNTRY: 'MC',
  SINGLE_COUNTRY: 'SC',
  TRACKER: 'TRC',
} as const;

export type TemplateType = (typeof TEMPLATE_TYPE)[keyof typeof TEMPLATE_TYPE];

export const TEMPLATE_MESSAGES = {
  MULTI_COUNTRY_NOT_SUPPORTED:
    'Multi-country templates cannot be applied yet, support is in progress. Please select a single country template.',
} as const;

export const TEMPLATE_CHANGE_CONFIRMATION = {
  TITLE: 'Apply Template',
  MESSAGE:
    'You are changing the template, do you want to delete the current survey?',
  DELETE_LABEL: 'Yes, delete the survey',
  KEEP_LABEL: 'No, keep the survey as a draft',
  CANCEL_LABEL: 'Cancel',
} as const;
